const navigationItems = [
  {
    label: 'HOME',
    path: '/',
    isOuter: false,
  },
  {
    label: '회사소개',
    path: '/company',
    isOuter: false,
  },
  {
    label: '줄눈시공대상',
    path: '/targets',
    isOuter: false,
  },
  {
    label: '줄눈이란',
    path: '/info',
    isOuter: false,
  },
  {
    label: '줄눈시공사례',
    path: '/gallery',
    isOuter: false,
    // path: process.env.REACT_APP_GALLERY_URL,
    // isOuter: !!process.env.REACT_APP_GALLERY_URL.match(/^http/),
    // target: '_blank',
  },
  {
    label: '줄눈가격',
    path: '/price',
    isOuter: false,
  },
  {
    label: '상담/예약문의',
    path: '/reservation',
    isOuter: false,
  },
];

export const navigationItemsMobile = navigationItems.map((item) => ({ ...item, path: item.isOuter ? item.path : `/m${item.path}` }));

export default navigationItems;
